import ApiService from "./api.service";

const RequestRatingService = {
  GetByDocNumber(docNumber) {
    return ApiService.get(`/RequestRating/GetByDocNumber/${docNumber}`);
  },
  GetList(filter) {
    return ApiService.post(`/RequestRating/GetList`, filter);
  },
  Get(id) {
    return ApiService.get(`/RequestRating/Get/${id}`);
  },
  Create(data) {
    return ApiService.post(`/RequestRating/Create`, data);
  },
};

export default RequestRatingService;
